<template>
  <div style="color: #666; font-size: 14px">

    <el-row :gutter="24">
      <el-col :span="14">
        <el-carousel height="550px" :interval="5000">
          <el-carousel-item v-for="item in imgs" :key="item">
            <img :src="item" style="width: 100%; height: 100%" />
          </el-carousel-item>
        </el-carousel>
      </el-col>

      <el-col :span="10">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>系统技术选型</span>
          </div>
          <div class="text item">
            操作系统: Windows10/11
          </div>
          <div class="text item">
            开发工具: Idea
          </div>
          <div class="text item">
            系统架构: 前后端分离B/S架构
          </div>
          <div class="text item">
            后端: SpringBoot+MybatisPlus
          </div>
          <div class="text item">
            前端: Vue+ElementUI+Axios
          </div>
          <div class="text item">
            数据库: Mysql5.7/8.0
          </div>
        </el-card>

        <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">
            <span>系统运行方式</span>
          </div>

          <div class="text item">
            后端:jdk1.8，依赖管理maven，idea运行SpringBoot服务
          </div>
          <div class="text item">
            前端:nodejs16
          </div>
          <div class="text item">
            运行web地址:
            <el-link type="success">http://localhost:8080</el-link>
          </div>
        </el-card>
      </el-col>
    </el-row>




  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      imgs: [
        "http://47.108.174.230:9090/file/df8600e548094835a8bf62de0bbe6448.jpg",
        "http://47.108.174.230:9090/file/33ff3365f5a647b6819e66fd44d18f3f.jpg",
      ],
    };
  },
};
</script>

<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}

.box-card {
  width: 480px;
}
</style>

